export function filesMatch(a: File, b: File): boolean {
  return a.name === b.name && a.lastModified === b.lastModified;
}

export function getFileKey(file: File): string {
  return `${file.name}-${file.lastModified}`;
}
